import { Injectable } from "@angular/core";
import { Location, LocationAvailabilityDto, LocationAvailabilityRequestDto, LocationShort } from "@app/models";
import { LocationsService as LocationsApiService, nonFalsyPayload } from "clearline-api";
import { Observable } from "rxjs";

// todo: migrate this service to clearline-api lib
@Injectable({ providedIn: "root" })
export class LocationService extends LocationsApiService {
  // Data handlers:

  static getLocationFullName(loc: Location): string {
    return `${loc.companyName}, ${loc.address}, ${loc.city}, ${loc.state}, ${loc.zip}`;
  }

  // API calls:

  getAll(): Observable<Location[]> {
    return this.api.get(`${this.serviceUrl}`);
  }
  getAllList(): Observable<Location[]> {
    return this.api.post(`${this.serviceUrl}/list`);
  }
  getLocationsAvailability(payload: LocationAvailabilityRequestDto): Observable<LocationAvailabilityDto[]> {
    return this.api.get(`${this.serviceUrl}/list/availability`, payload);
  }
  create(location: Location): Observable<Location> {
    return this.api.post(`${this.serviceUrl}`, location);
  }
  update(location: Location): Observable<Location> {
    return this.api.put(`${this.serviceUrl}`, location);
  }

  getUserLocations(userId: number): Observable<Location[]> {
    return this.api.get(`${this.serviceUrl}/user/${userId}`);
  }

  getLocationsShort(includeLocationIds: number[] = [], top: number = 20, searchValue: string = ""): Observable<LocationShort[]> {
    const params = {
      includeLocationIds,
      top,
      searchValue
    };
    return this.api.get(`${this.serviceUrl}/short`, nonFalsyPayload(params));
  }

  updateUserLocations(userId: number, selectedLocations: number[]): Observable<Location[]> {
    return this.api.post(`${this.serviceUrl}/user/${userId}`, selectedLocations);
  }

  getLocationsForWidget(widgetId: number): Observable<Location[]> {
    return this.api.get(`${this.serviceUrl}/widget/${widgetId}`);
  }

  getAccountLocations(accountId: number): Observable<Location[]> {
    return this.api.get(`${this.serviceUrl}/account/${accountId}`);
  }
}
